// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2IGYv","head":"ProcedureTableInfo_head__Hc9ME"};